import { TICK_RATE, type PlayerState } from "@arena/shared";

/** Life is separate from the gold Slam meter and exists only in Arena KO. */
export class HealthBar {
  private readonly root = document.createElement("div");
  private readonly fill = document.createElement("i");
  private readonly value = document.createElement("span");
  private rendered = "";

  constructor(label: HTMLElement) {
    this.root.className = "fighter-health";
    this.root.hidden = true;
    this.root.setAttribute("role","progressbar");
    this.root.setAttribute("aria-label","Vita");
    this.root.setAttribute("aria-valuemin","0");
    this.root.append(this.fill,this.value);
    label.append(this.root);
  }

  update(player: PlayerState, enabled: boolean): void {
    this.root.hidden = !enabled;
    if (!enabled) return;
    const seconds = Math.ceil(player.respawnTicks / TICK_RATE);
    // In a match nobody comes back (D42): the countdown is training's.
    const text = player.knockedOut ? (seconds > 0 ? `KO · ${seconds}s` : "Eliminato") : `${player.hp} / ${player.maxHp}`;
    const key = `${text}|${player.spawnShieldTicks>0}`;
    if (key === this.rendered) return;
    this.rendered = key;
    this.fill.style.width = `${100 * player.hp / Math.max(1,player.maxHp)}%`;
    this.root.classList.toggle("low",player.hp <= 30);
    this.root.classList.toggle("protected",player.spawnShieldTicks > 0);
    this.root.setAttribute("aria-valuenow",String(player.hp));
    this.root.setAttribute("aria-valuemax",String(player.maxHp));
    this.root.setAttribute("aria-valuetext",text);
    this.value.textContent = text;
  }
}
